<template>
  <v-navigation-drawer  color="rgba(0,0,0,0.9)" dark width="300px" :value="navigationBar" v-on:input="OnNavigationBarInput" :temporary="$vuetify.breakpoint.smAndDown" :touchless="true">
      <v-toolbar dense color="transparent">
        <v-spacer/>
        <v-btn dark @click="SetNavigationBar(false)" icon text class="mr-1">
          <v-icon color="white">
            mdi-close
          </v-icon>
        </v-btn>
      </v-toolbar>
      <v-row>
        <v-col cols="12" class="pb-0 pt-0">
          <v-img
          height="200px"
          contain
          :src="(activeMapImage == '') ?  'https://xpcwa.blob.core.windows.net/mapimages/EH/Asset_MAP_Entrance_Featured_Herb%20Elliott%20.png' : activeMapImage"
          >
          </v-img>
        </v-col>
      </v-row>
      <v-divider></v-divider>
      <v-list v-if="activeTour == null">
        <v-list-group
          v-for="(navGroup, index) in NavigationGroups"
          :key="index"
          dense
          :value="activNavGrp == navGroup.name"
          @click="OnClickNavGrp(navGroup)"
          :color="navGroup.color"
          :active-class="(index == 0) ? 'orangeBack' : 'tealBack'"
        >
          <template v-slot:activator>
            <v-list-item-content :style="'color:' + navGroup.color + ';'" class="caption pt-2 pb-2">{{navGroup.name}}</v-list-item-content>
          </template>

          <div v-if="navGroup.locations.length == 0">
            <v-list-item>
              <v-list-item-content class="caption pl-4">
                Coming soon..
              </v-list-item-content>
            </v-list-item>
          </div>
          <div v-else-if="navGroup.locations.length == 1">
              <v-list-item
              v-for="(navPoint, i) in navGroup.locations[0].navPoints"
              :key="i"
              link
              dense
              @click="(navPoint.touchpointid == -1) ? OnClickWaypoint(navPoint.waypointid) : OnClickTouchpoint(navPoint)"
              class="pb-0 pt-0 ml-4"
            >
              <v-list-item-content :style="(navPoint.waypointid == activeWaypointid) ? 'color:' + navGroup.color + ';' : ''" class="caption" v-text="navPoint.name"></v-list-item-content>

            </v-list-item>
          </div>
          <div v-else v-for="(location, locationIndex) in navGroup.locations" :key="locationIndex" style="">
            <v-list-group
              v-if="location.navPoints.length > 0 && !location.noGroup"
              sub-group
              append-icon="mdi-plus"
              dense
              :group="location.id"
              @click="OnClickLocationHeader(navGroup,location)"
              :value="(navGroup.locationModel == location.id)"
              :color="navGroup.color"
            >
              <template v-slot:activator>
                <v-list-item-content class="caption pa-0 ma-0">{{location.name}}</v-list-item-content>
              </template>

              <v-list-item
                v-for="(navPoint, i) in location.navPoints"
                :key="i"
                link
                dense
                @click="(navPoint.touchpointid == -1) ? OnClickWaypoint(navPoint.waypointid) : OnClickTouchpoint(navPoint)"
                class="pb-0 pt-0"
              >
                <v-list-item-content :style="(navPoint.waypointid == activeWaypointid && !location.disableWaypointHighlight) ? 'color:' + navGroup.color + ';' : ''" class="caption" v-text="navPoint.name"></v-list-item-content>

              </v-list-item>
            </v-list-group>
            <template v-else-if="location.navPoints.length > 0 && location.noGroup">
              <v-list-item
                v-for="(navPoint, i) in location.navPoints"
                :key="i"
                link
                dense
                @click="(navPoint.touchpointid == -1) ? OnClickWaypoint(navPoint.waypointid) : OnClickTouchpoint(navPoint)"
                class="pb-0 pt-0 ml-4"
              >
                <v-list-item-content :style="(navPoint.waypointid == activeWaypointid && !location.disableWaypointHighlight) ? 'color:' + navGroup.color + ';' : ''" class="caption" v-text="navPoint.name"></v-list-item-content>

              </v-list-item>
            </template>
            <v-list-item v-else-if="location.navPoints.length == 0" dense>
              <v-list-item-content class="caption pl-5 font-weight-bold">
                {{location.name}}
              </v-list-item-content>
            </v-list-item>
          </div>
        </v-list-group>
      </v-list>
      <v-list v-else nav>
        <v-list-item dense class="mb-0 mt-0">
          <v-list-item-content class="title">
            {{activeTour.name}}
          </v-list-item-content>
        </v-list-item>
        <div v-for="(tourPoint,index) in activeTour.tourPoints" :key="index">
           <v-list-item dense v-if="tourPoint.priorTitle != ''" class="mb-0 mt-0">
            <v-list-item-content class="subtitle-1 text-weight-bold">
              {{tourPoint.priorTitle}}
            </v-list-item-content>
          </v-list-item>
          <v-list-item dense link class="mt-0 mb-0" @click="OnTapStep(index)">
            <v-list-item-icon>
              {{tourPoint.stepPrefix}}
            </v-list-item-icon>
            <v-list-item-content :style="(index < activeTourIndex) ? 'color:red;' : ''">
              {{tourPoint.name}}
            </v-list-item-content>
          </v-list-item>
        </div>
      </v-list>
    </v-navigation-drawer>
</template>

<script>

import {mapState,mapMutations, mapGetters} from 'vuex'
  export default {
    name: 'NavigationBar',
    components: {
    },
    props: {
    },
    computed: {
      
      ...mapState("sessionState", [
        "currentLanguage",
        "navigationBar",
        "package",
        "activeWaypointid",
        "currentStage",
        "activeTour",
        "activeTourIndex",
      ]),

      ...mapGetters("sessionState", [
        "CurrentStageData"
      ]),


      NavigationGroups ()
      {
        return this.package.navGroups;
      },

      mapGroups()
      {

      },

      currentWaypointName()
      {
       let waypoint = this.currentStage.typeData.waypoints.find(w => w.id == this.activeWaypointid);

        if(waypoint == null)
        {
          return "";
        }
        else
        {
          return waypoint.name;
        }
      }

    },

    mounted () {

    },
    data: () => ({

      
      activNavGrp : "",
      activeMapImage : "",
      items: [
        { title: 'Dashboard', icon: 'mdi-view-dashboard' },
        { title: 'Photos', icon: 'mdi-image' },
        { title: 'About', icon: 'mdi-help-box' },
      ],
      right: null,
      openGroups : false,
      model : null,
      lastSelected : null,
      admins: [
        ['Management', 'mdi-account-multiple-outline'],
        ['Settings', 'mdi-cog-outline'],
      ],
      cruds: [
        ['Create', 'mdi-plus-outline'],
        ['Read', 'mdi-file-outline'],
        ['Update', 'mdi-update'],
        ['Delete', 'mdi-delete'],
      ],

    }),
    methods: {

      ...mapMutations("sessionState", [
        "SetCurrentLanguage",
        "SetNavigationBar",
        "SetForceLandRotation",
        "SetTouchpointToIndex"
      ]),
      OnClickNavGrp(navGrp)
      {
        this.$nextTick(() => {
          this.activNavGrp = navGrp.name
        })
      },
      OnTapStep(index)
      {
        if(this.$vuetify.breakpoint.smAndDown)
        {
          this.SetNavigationBar(false);
        }
        this.SetForceLandRotation(true);
        this.SetTouchpointToIndex(index);
      },
      OnClickWaypoint(waypointid)
      {
        if(this.$vuetify.breakpoint.smAndDown)
        {
          this.SetNavigationBar(false);
        }
        let waypoint = this.currentStage.typeData.waypoints.find(w => w.id == waypointid);
        this.SetForceLandRotation(true);
        this.$emit("OnWaypointTap",waypoint);
      },
      OnClickTouchpoint(navPoint)
      {
        if(this.$vuetify.breakpoint.smAndDown)
        {
          this.SetNavigationBar(false);
        }
        this.SetForceLandRotation(true);
        this.$emit("OnTouchpointTap",navPoint);
      },
      OnClickLocationHeader(navGrp, location)
      {
        this.$nextTick(() => {
          if(navGrp.locationModel == null)
            this.$set(navGrp, 'locationModel', location.id);
          else
            navGrp.locationModel = location.id;
        })
        
      },
      OnNavigationBarInput(inputState)
      {
        this.SetNavigationBar(inputState);
      }

    },
    watch: {

      activeTourIndex : {

        handler(newVal)
        {
          if(this.activeTour != null)
          {
            this.activeMapImage = this.activeTour.tourPoints[newVal].mapImageUrl;
          }
          else
          {
            this.SetForceLandRotation(true);
            this.$emit("NavigateToWaypoint",this.CurrentStageData.waypoints[0].id);
          }
        }
      },
      activeWaypointid : {

        handler(newid)
        {
          if(this.activeTour != null)
            return;


          let waypoint = this.currentStage.typeData.waypoints.find(w => w.id == newid);

          //New waypoint navigated to, lets first update the map image if possible
          if(waypoint.customMapImage != null)
          {
            this.activeMapImage = waypoint.customMapImage;
          }
          else if (waypoint.locationid != null)
          {
            //We are part of a location group instead
          }


          //Now we've updated the map image, let's see if this item is inside a nav group or location so we can expand the correct menu
          let foundNavGrp = null;
          if(waypoint.navGroupName != "")
          {
            foundNavGrp = this.NavigationGroups.find(navGrp => navGrp.name == waypoint.navGroupName);
          }
          else if(waypoint.locationid != "")
          {
            foundNavGrp = this.NavigationGroups.find(navGrp => navGrp.locations.some(location => location.id == waypoint.locationid));
          }
        
          if(foundNavGrp != null)
          {
            this.activNavGrp = foundNavGrp.name;
          }

          console.log("Hello world", foundNavGrp);

          if(foundNavGrp != null)
          {
            //Now if we have a locationid, we can only open up the specific location
            this.$nextTick(() => {
              if(waypoint.locationid != "")
              {
                if(foundNavGrp.locationModel == null)
                  this.$set(foundNavGrp, 'locationModel', waypoint.locationid);
                else
                  foundNavGrp.locationModel = waypoint.locationid;
              }
              else
              {
                if(foundNavGrp != null)
                {
                  if(foundNavGrp.locationModel == null)
                    this.$set(foundNavGrp, 'locationModel', '');
                  else
                    foundNavGrp.locationModel = '';
                }
              }
            });
          }
        }
      }
      
    }
  }
</script>

<style>
.v-list-item {
  min-height: 5px!important;
}
.v-list-group__header__prepend-icon{

  margin-top: 3px;
  margin-bottom: 3px;
}
.orangeBack {
  background-color :rgba(254, 138, 76, 0.2);
}
.tealBack{
  background-color :rgba(105, 213, 224, 0.2);
}
</style>
